export class ClockSynchronizer {
  private samples: number[] = [];
  observe(serverTime: string | number, localReceivedAt = Date.now(), roundTripMs = 0): void {
    const serverMs = typeof serverTime === "number" ? serverTime : Date.parse(serverTime);
    if (!Number.isFinite(serverMs)) return;
    const offset = serverMs + roundTripMs / 2 - localReceivedAt;
    this.samples.push(offset);
    if (this.samples.length > 7) this.samples.shift();
  }
  get offsetMs(): number { if (!this.samples.length) return 0; return [...this.samples].sort((a, b) => a - b)[Math.floor(this.samples.length / 2)] ?? 0; }
  now(localNow = Date.now()): number { return localNow + this.offsetMs; }
}
